
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.498 21.492c-.666 1.153-2.33 1.153-2.996 0L3.014 8.522C2.35 7.37 3.181 5.93 4.512 5.93h14.976c1.331 0 2.163 1.44 1.498 2.594l-7.488 12.97z","fill":"currentColor"}})])
          )
        }
      }
    